const DEFAULT_VALUES = {
  amount: 180000,
  duration: 5,
  occasions: 60,
  interest: 12.2,
  effectiveInterest: 12.91,
  totalCost: 241333,
  monthlyCost: 3286,
  startupFee: 950,
  monthlyFee: 40,
  cost: 61333
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const DEFAULT_VALUES_REFINANCE = {
  amount: 230000,
  duration: 6,
  occasions: 96,
  interest: 10.9,
  effectiveInterest: 11.46,
  totalCost: 314358,
  monthlyCost: 3383,
  startupFee: 950,
  monthlyFee: 40,
  cost: 84358
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const INTEREST = 13.8

// ? ******************************************************************************************
// ? ******************************************************************************************

const INTERESTS = [
  {
    amount: 0,
    interestRate: 13.8,
    startupFee: 450,
    monthlyFee: 40
  },
  {
    amount: 60000,
    interestRate: 11.6,
    startupFee: 950,
    monthlyFee: 40
  },
  {
    amount: 120000,
    interestRate: 10.8,
    startupFee: 950,
    monthlyFee: 40
  },
  {
    amount: 200000,
    interestRate: 10.7,
    startupFee: 950,
    monthlyFee: 40
  },
  {
    amount: 230000,
    interestRate: 9.8,
    startupFee: 950,
    monthlyFee: 40
  },
  {
    amount: 380000,
    interestRate: 9.5,
    startupFee: 950,
    monthlyFee: 40
  }
]

// ? ******************************************************************************************
// ? ******************************************************************************************

const DISCLAIMER = {
  nb: '<p>Renten er variabel og settes individuelt. Individuell nominell rente varierer fra 4,9–23,4 %. Effektiv rente varierer fra 5,01–37,54 %.<br>Eksempel: Nominell rente {interest}, effektiv rente {effectiveInterest}, {amount} over {duration} år, kostnad {cost}, totalt {totalCost}.</p><p>Søknaden din sendes til kredittgiverne som best passer din profil.</p>',
  en: '<p>Renten er variabel og settes individuelt. Individuell nominell rente varierer fra 4,9–23,4 %. Effektiv rente varierer fra 5,01–37,54 %.<br>Eksempel: Nominell rente {interest}, effektiv rente {effectiveInterest}, {amount} over {duration} år, kostnad {cost}, totalt {totalCost}.</p><p>Søknaden din sendes til kredittgiverne som best passer din profil.</p>'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

module.exports = {
  DEFAULT_VALUES,
  DEFAULT_VALUES_REFINANCE,
  INTEREST,
  INTERESTS,
  DISCLAIMER
}
